import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useFeatureEntitlements } from "@frontegg/react";

export interface TabConfig {
  label: string;
  groupKey: string;
  title: string;
  isInvisible?: boolean;
}

export const useSpendingTabs = () => {
  const { isEntitled: featureAllocations } = useFeatureEntitlements(
    "feature_allocations",
  );
  const { i18n } = useTranslation();

  return useMemo(() => {
    const tabs: TabConfig[] = [
      {
        label: "Categories",
        groupKey: "expenseCategory",
        title: "Top Categories",
      },
      { label: "Purchaser", groupKey: "userName", title: "Top Employee Spend" },
      { label: "Card", groupKey: "card", title: "Top Card Spend" },
      { label: "Merchant", groupKey: "merchant", title: "Top Merchants" },
      {
        label: "Allocations",
        groupKey: "allocationCode",
        title: "Top Allocations",
        isInvisible: !featureAllocations,
      },
    ];
    return tabs;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureAllocations, i18n.language]);
};
